// Gate pricing data from MAK_Preisliste_Vorlage.xlsx - Auto-generated

export const gatePricing = {
  'astral': {
    pedestrian: [
      { width: 135.0, height: 125.0, price: 505.0 },
      { width: 215.0, height: 125.0, price: 607.0 },
      { width: 275.0, height: 125.0, price: 871.0 },
      { width: 335.0, height: 125.0, price: 1049.0 },
      { width: 400.0, height: 125.0, price: 1994.0 },
      { width: 135.0, height: 150.0, price: 519.0 },
      { width: 215.0, height: 150.0, price: 699.0 },
      { width: 275.0, height: 150.0, price: 936.0 },
      { width: 335.0, height: 150.0, price: 1121.0 },
      { width: 400.0, height: 150.0, price: 2133.0 },
      { width: 135.0, height: 175.0, price: 558.0 },
      { width: 215.0, height: 175.0, price: 734.0 },
      { width: 275.0, height: 175.0, price: 1003.0 },
      { width: 335.0, height: 175.0, price: 1181.0 },
      { width: 400.0, height: 175.0, price: 2204.0 },
      { width: 135.0, height: 200.0, price: 593.0 },
      { width: 215.0, height: 200.0, price: 769.0 },
      { width: 275.0, height: 200.0, price: 1068.0 },
      { width: 335.0, height: 200.0, price: 1244.0 },
      { width: 400.0, height: 200.0, price: 2277.0 },
    ],
    double: [
      { width: 335.0, height: 125.0, price: 1126.0 },
      { width: 415.0, height: 125.0, price: 1271.0 },
      { width: 515.0, height: 125.0, price: 1545.0 },
      { width: 615.0, height: 125.0, price: 1700.0 },
      { width: 715.0, height: 125.0, price: 3024.0 },
      { width: 335.0, height: 150.0, price: 1193.0 },
      { width: 415.0, height: 150.0, price: 1348.0 },
      { width: 515.0, height: 150.0, price: 1633.0 },
      { width: 615.0, height: 150.0, price: 1811.0 },
      { width: 715.0, height: 150.0, price: 3124.0 },
      { width: 335.0, height: 175.0, price: 1258.0 },
      { width: 415.0, height: 175.0, price: 1424.0 },
      { width: 515.0, height: 175.0, price: 1723.0 },
      { width: 615.0, height: 175.0, price: 1903.0 },
      { width: 715.0, height: 175.0, price: 3228.0 },
      { width: 335.0, height: 200.0, price: 1324.0 },
      { width: 415.0, height: 200.0, price: 1503.0 },
      { width: 515.0, height: 200.0, price: 1811.0 },
      { width: 615.0, height: 200.0, price: 2010.0 },
      { width: 715.0, height: 200.0, price: 3333.0 },
    ],
    sliding: [
      { width: 325.0, height: 125.0, price: 1969.0 },
      { width: 375.0, height: 125.0, price: 2110.0 },
      { width: 425.0, height: 125.0, price: 2265.0 },
      { width: 475.0, height: 125.0, price: 2443.0 },
      { width: 525.0, height: 125.0, price: 2825.0 },
      { width: 625.0, height: 125.0, price: 3791.0 },
      { width: 675.0, height: 125.0, price: 3969.0 },
      { width: 725.0, height: 125.0, price: 4159.0 },
      { width: 825.0, height: 125.0, price: 4539.0 },
      { width: 325.0, height: 150.0, price: 2028.0 },
      { width: 375.0, height: 150.0, price: 2170.0 },
      { width: 425.0, height: 150.0, price: 2336.0 },
      { width: 475.0, height: 150.0, price: 2517.0 },
      { width: 525.0, height: 150.0, price: 2908.0 },
      { width: 625.0, height: 150.0, price: 3876.0 },
      { width: 675.0, height: 150.0, price: 4064.0 },
      { width: 725.0, height: 150.0, price: 4256.0 },
      { width: 825.0, height: 150.0, price: 4646.0 },
      { width: 325.0, height: 175.0, price: 2087.0 },
      { width: 375.0, height: 175.0, price: 2230.0 },
      { width: 425.0, height: 175.0, price: 2408.0 },
      { width: 475.0, height: 175.0, price: 2589.0 },
      { width: 525.0, height: 175.0, price: 2992.0 },
      { width: 625.0, height: 175.0, price: 3955.0 },
      { width: 675.0, height: 175.0, price: 4159.0 },
      { width: 725.0, height: 175.0, price: 4349.0 },
      { width: 825.0, height: 175.0, price: 4756.0 },
      { width: 325.0, height: 200.0, price: 2145.0 },
      { width: 375.0, height: 200.0, price: 2290.0 },
      { width: 425.0, height: 200.0, price: 2480.0 },
      { width: 475.0, height: 200.0, price: 2658.0 },
      { width: 525.0, height: 200.0, price: 3075.0 },
      { width: 625.0, height: 200.0, price: 4041.0 },
      { width: 675.0, height: 200.0, price: 4256.0 },
      { width: 725.0, height: 200.0, price: 4446.0 },
      { width: 825.0, height: 200.0, price: 4863.0 },
    ],
  },
  'eclipse': {
    pedestrian: [
      { width: 135.0, height: 130.0, price: 612.0 },
      { width: 215.0, height: 130.0, price: 836.0 },
      { width: 335.0, height: 130.0, price: 1343.0 },
      { width: 400.0, height: 130.0, price: 2263.0 },
      { width: 135.0, height: 150.0, price: 651.0 },
      { width: 215.0, height: 150.0, price: 876.0 },
      { width: 335.0, height: 150.0, price: 1383.0 },
      { width: 400.0, height: 150.0, price: 2446.0 },
      { width: 135.0, height: 200.0, price: 690.0 },
      { width: 215.0, height: 200.0, price: 917.0 },
      { width: 335.0, height: 200.0, price: 1422.0 },
      { width: 400.0, height: 200.0, price: 2550.0 },
    ],
    double: [
      { width: 365.0, height: 130.0, price: 1404.0 },
      { width: 415.0, height: 130.0, price: 1563.0 },
      { width: 550.0, height: 130.0, price: 2253.0 },
      { width: 615.0, height: 130.0, price: 3575.0 },
      { width: 365.0, height: 150.0, price: 1529.0 },
      { width: 415.0, height: 150.0, price: 1684.0 },
      { width: 550.0, height: 150.0, price: 2348.0 },
      { width: 615.0, height: 150.0, price: 3670.0 },
      { width: 365.0, height: 200.0, price: 1651.0 },
      { width: 415.0, height: 200.0, price: 1808.0 },
      { width: 550.0, height: 200.0, price: 2543.0 },
      { width: 615.0, height: 200.0, price: 3863.0 },
    ],
    sliding: [
      { width: 325.0, height: 130.0, price: 2202.0 },
      { width: 375.0, height: 130.0, price: 2327.0 },
      { width: 425.0, height: 130.0, price: 2450.0 },
      { width: 475.0, height: 130.0, price: 2573.0 },
      { width: 525.0, height: 130.0, price: 2944.0 },
      { width: 625.0, height: 130.0, price: 3529.0 },
      { width: 710.0, height: 130.0, price: 3729.0 },
      { width: 800.0, height: 130.0, price: 5621.0 },
      { width: 325.0, height: 150.0, price: 2314.0 },
      { width: 375.0, height: 150.0, price: 2436.0 },
      { width: 425.0, height: 150.0, price: 2561.0 },
      { width: 475.0, height: 150.0, price: 2684.0 },
      { width: 525.0, height: 150.0, price: 3078.0 },
      { width: 625.0, height: 150.0, price: 3673.0 },
      { width: 710.0, height: 150.0, price: 3807.0 },
      { width: 800.0, height: 150.0, price: 5701.0 },
      { width: 325.0, height: 200.0, price: 2427.0 },
      { width: 375.0, height: 200.0, price: 2550.0 },
      { width: 425.0, height: 200.0, price: 2691.0 },
      { width: 475.0, height: 200.0, price: 2814.0 },
      { width: 525.0, height: 200.0, price: 3212.0 },
      { width: 625.0, height: 200.0, price: 3824.0 },
      { width: 710.0, height: 200.0, price: 3971.0 },
      { width: 800.0, height: 200.0, price: 5864.0 },
    ],
  },
  'galactic': {
    pedestrian: [
      { width: 135.0, height: 100.0, price: 1016.0 },
      { width: 170.0, height: 100.0, price: 1155.0 },
      { width: 210.0, height: 100.0, price: 1311.0 },
      { width: 270.0, height: 100.0, price: 1561.0 },
      { width: 330.0, height: 100.0, price: 1725.0 },
      { width: 135.0, height: 125.0, price: 1074.0 },
      { width: 170.0, height: 125.0, price: 1248.0 },
      { width: 210.0, height: 125.0, price: 1403.0 },
      { width: 270.0, height: 125.0, price: 1656.0 },
      { width: 330.0, height: 125.0, price: 1822.0 },
      { width: 135.0, height: 150.0, price: 1132.0 },
      { width: 170.0, height: 150.0, price: 1343.0 },
      { width: 210.0, height: 150.0, price: 1498.0 },
      { width: 270.0, height: 150.0, price: 1751.0 },
      { width: 330.0, height: 150.0, price: 1917.0 },
      { width: 135.0, height: 175.0, price: 1186.0 },
      { width: 170.0, height: 175.0, price: 1438.0 },
      { width: 210.0, height: 175.0, price: 1593.0 },
      { width: 270.0, height: 175.0, price: 1848.0 },
      { width: 330.0, height: 175.0, price: 2013.0 },
      { width: 135.0, height: 200.0, price: 1246.0 },
      { width: 170.0, height: 200.0, price: 1536.0 },
      { width: 210.0, height: 200.0, price: 1693.0 },
      { width: 270.0, height: 200.0, price: 1943.0 },
      { width: 330.0, height: 200.0, price: 2094.0 },
    ],
    double: [
      { width: 240.0, height: 100.0, price: 1969.0 },
      { width: 330.0, height: 100.0, price: 2135.0 },
      { width: 420.0, height: 100.0, price: 2457.0 },
      { width: 510.0, height: 100.0, price: 2675.0 },
      { width: 600.0, height: 100.0, price: 3154.0 },
      { width: 240.0, height: 125.0, price: 2080.0 },
      { width: 330.0, height: 125.0, price: 2249.0 },
      { width: 420.0, height: 125.0, price: 2346.0 },
      { width: 510.0, height: 125.0, price: 2788.0 },
      { width: 600.0, height: 125.0, price: 3263.0 },
      { width: 240.0, height: 150.0, price: 2191.0 },
      { width: 330.0, height: 150.0, price: 2360.0 },
      { width: 420.0, height: 150.0, price: 2680.0 },
      { width: 510.0, height: 150.0, price: 2899.0 },
      { width: 600.0, height: 150.0, price: 3376.0 },
      { width: 240.0, height: 175.0, price: 2306.0 },
      { width: 330.0, height: 175.0, price: 2471.0 },
      { width: 420.0, height: 175.0, price: 2791.0 },
      { width: 510.0, height: 175.0, price: 3011.0 },
      { width: 600.0, height: 175.0, price: 3488.0 },
      { width: 240.0, height: 200.0, price: 2416.0 },
      { width: 330.0, height: 200.0, price: 2587.0 },
      { width: 420.0, height: 200.0, price: 2908.0 },
      { width: 510.0, height: 200.0, price: 3124.0 },
      { width: 600.0, height: 200.0, price: 3601.0 },
    ],
    sliding: [
      { width: 330.0, height: 100.0, price: 2930.0 },
      { width: 380.0, height: 100.0, price: 3168.0 },
      { width: 430.0, height: 100.0, price: 3381.0 },
      { width: 480.0, height: 100.0, price: 3654.0 },
      { width: 530.0, height: 100.0, price: 4078.0 },
      { width: 620.0, height: 100.0, price: 4382.0 },
      { width: 710.0, height: 100.0, price: 6693.0 },
      { width: 800.0, height: 100.0, price: 7316.0 },
      { width: 330.0, height: 125.0, price: 3062.0 },
      { width: 380.0, height: 125.0, price: 3265.0 },
      { width: 430.0, height: 125.0, price: 3509.0 },
      { width: 480.0, height: 125.0, price: 3749.0 },
      { width: 530.0, height: 125.0, price: 4176.0 },
      { width: 620.0, height: 125.0, price: 4481.0 },
      { width: 710.0, height: 125.0, price: 6795.0 },
      { width: 800.0, height: 125.0, price: 7406.0 },
      { width: 330.0, height: 150.0, price: 3198.0 },
      { width: 380.0, height: 150.0, price: 3362.0 },
      { width: 430.0, height: 150.0, price: 3643.0 },
      { width: 480.0, height: 150.0, price: 3846.0 },
      { width: 530.0, height: 150.0, price: 4270.0 },
      { width: 620.0, height: 150.0, price: 4576.0 },
      { width: 710.0, height: 150.0, price: 6894.0 },
      { width: 800.0, height: 150.0, price: 7492.0 },
      { width: 330.0, height: 175.0, price: 3330.0 },
      { width: 380.0, height: 175.0, price: 3457.0 },
      { width: 430.0, height: 175.0, price: 3775.0 },
      { width: 480.0, height: 175.0, price: 3942.0 },
      { width: 530.0, height: 175.0, price: 4368.0 },
      { width: 620.0, height: 175.0, price: 4669.0 },
      { width: 710.0, height: 175.0, price: 6987.0 },
      { width: 330.0, height: 200.0, price: 3465.0 },
      { width: 380.0, height: 200.0, price: 3552.0 },
      { width: 430.0, height: 200.0, price: 3909.0 },
      { width: 480.0, height: 200.0, price: 4039.0 },
      { width: 530.0, height: 200.0, price: 4465.0 },
      { width: 620.0, height: 200.0, price: 4771.0 },
      { width: 710.0, height: 200.0, price: 7088.0 },
    ],
  },
  'orbit': {
    pedestrian: [
      { width: 120.0, height: 98.0, price: 882.0 },
      { width: 170.0, height: 98.0, price: 1003.0 },
      { width: 210.0, height: 98.0, price: 1140.0 },
      { width: 270.0, height: 98.0, price: 1357.0 },
      { width: 330.0, height: 98.0, price: 1500.0 },
      { width: 120.0, height: 123.0, price: 933.0 },
      { width: 170.0, height: 123.0, price: 1084.0 },
      { width: 210.0, height: 123.0, price: 1220.0 },
      { width: 270.0, height: 123.0, price: 1440.0 },
      { width: 330.0, height: 123.0, price: 1584.0 },
      { width: 120.0, height: 148.0, price: 984.0 },
      { width: 170.0, height: 148.0, price: 1167.0 },
      { width: 210.0, height: 148.0, price: 1302.0 },
      { width: 270.0, height: 148.0, price: 1522.0 },
      { width: 330.0, height: 148.0, price: 1667.0 },
      { width: 120.0, height: 173.0, price: 1031.0 },
      { width: 170.0, height: 173.0, price: 1250.0 },
      { width: 210.0, height: 173.0, price: 1385.0 },
      { width: 270.0, height: 173.0, price: 1607.0 },
      { width: 330.0, height: 173.0, price: 1751.0 },
      { width: 120.0, height: 198.0, price: 1246.0 },
      { width: 170.0, height: 198.0, price: 1336.0 },
      { width: 210.0, height: 198.0, price: 1471.0 },
      { width: 270.0, height: 198.0, price: 1690.0 },
      { width: 330.0, height: 198.0, price: 1822.0 },
    ],
    double: [
      { width: 240.0, height: 98.0, price: 1712.0 },
      { width: 330.0, height: 98.0, price: 1857.0 },
      { width: 420.0, height: 98.0, price: 2137.0 },
      { width: 510.0, height: 98.0, price: 2327.0 },
      { width: 600.0, height: 98.0, price: 2742.0 },
      { width: 240.0, height: 123.0, price: 1809.0 },
      { width: 330.0, height: 123.0, price: 1955.0 },
      { width: 420.0, height: 123.0, price: 2040.0 },
      { width: 510.0, height: 123.0, price: 2424.0 },
      { width: 600.0, height: 123.0, price: 2837.0 },
      { width: 240.0, height: 148.0, price: 1904.0 },
      { width: 330.0, height: 148.0, price: 2052.0 },
      { width: 420.0, height: 148.0, price: 2330.0 },
      { width: 510.0, height: 148.0, price: 2520.0 },
      { width: 600.0, height: 148.0, price: 2936.0 },
      { width: 240.0, height: 173.0, price: 2005.0 },
      { width: 330.0, height: 173.0, price: 2149.0 },
      { width: 420.0, height: 173.0, price: 2427.0 },
      { width: 510.0, height: 173.0, price: 2619.0 },
      { width: 600.0, height: 173.0, price: 3032.0 },
      { width: 240.0, height: 198.0, price: 2101.0 },
      { width: 330.0, height: 198.0, price: 2249.0 },
      { width: 420.0, height: 198.0, price: 2527.0 },
      { width: 510.0, height: 198.0, price: 2716.0 },
      { width: 600.0, height: 198.0, price: 3131.0 },
    ],
    sliding: [
      { width: 330.0, height: 98.0, price: 2548.0 },
      { width: 380.0, height: 98.0, price: 2754.0 },
      { width: 430.0, height: 98.0, price: 2939.0 },
      { width: 480.0, height: 98.0, price: 3177.0 },
      { width: 530.0, height: 98.0, price: 3546.0 },
      { width: 620.0, height: 98.0, price: 3810.0 },
      { width: 710.0, height: 98.0, price: 5820.0 },
      { width: 800.0, height: 98.0, price: 6362.0 },
      { width: 330.0, height: 123.0, price: 2663.0 },
      { width: 380.0, height: 123.0, price: 2839.0 },
      { width: 430.0, height: 123.0, price: 3052.0 },
      { width: 480.0, height: 123.0, price: 3260.0 },
      { width: 530.0, height: 123.0, price: 3631.0 },
      { width: 620.0, height: 123.0, price: 3897.0 },
      { width: 710.0, height: 123.0, price: 5908.0 },
      { width: 800.0, height: 123.0, price: 6440.0 },
      { width: 330.0, height: 148.0, price: 2781.0 },
      { width: 380.0, height: 148.0, price: 2923.0 },
      { width: 430.0, height: 148.0, price: 3168.0 },
      { width: 480.0, height: 148.0, price: 3344.0 },
      { width: 530.0, height: 148.0, price: 3712.0 },
      { width: 620.0, height: 148.0, price: 3979.0 },
      { width: 710.0, height: 148.0, price: 5995.0 },
      { width: 800.0, height: 148.0, price: 6516.0 },
      { width: 330.0, height: 173.0, price: 2895.0 },
      { width: 380.0, height: 173.0, price: 3006.0 },
      { width: 430.0, height: 173.0, price: 3282.0 },
      { width: 480.0, height: 173.0, price: 3428.0 },
      { width: 530.0, height: 173.0, price: 3798.0 },
      { width: 620.0, height: 173.0, price: 4060.0 },
      { width: 710.0, height: 173.0, price: 6076.0 },
      { width: 330.0, height: 198.0, price: 3013.0 },
      { width: 380.0, height: 198.0, price: 3089.0 },
      { width: 430.0, height: 198.0, price: 3399.0 },
      { width: 480.0, height: 198.0, price: 3511.0 },
      { width: 530.0, height: 198.0, price: 3883.0 },
      { width: 620.0, height: 198.0, price: 4148.0 },
      { width: 710.0, height: 198.0, price: 6164.0 },
    ],
  },
  'stellar': {
    pedestrian: [
      { width: 135.0, height: 125.0, price: 586.0 },
      { width: 215.0, height: 125.0, price: 755.0 },
      { width: 315.0, height: 125.0, price: 1107.0 },
      { width: 365.0, height: 125.0, price: 1890.0 },
      { width: 400.0, height: 125.0, price: 2072.0 },
      { width: 135.0, height: 150.0, price: 639.0 },
      { width: 215.0, height: 150.0, price: 810.0 },
      { width: 315.0, height: 150.0, price: 1190.0 },
      { width: 365.0, height: 150.0, price: 1998.0 },
      { width: 400.0, height: 150.0, price: 2188.0 },
      { width: 135.0, height: 175.0, price: 690.0 },
      { width: 215.0, height: 175.0, price: 862.0 },
      { width: 315.0, height: 175.0, price: 1264.0 },
      { width: 365.0, height: 175.0, price: 2101.0 },
      { width: 400.0, height: 175.0, price: 2304.0 },
      { width: 135.0, height: 200.0, price: 743.0 },
      { width: 215.0, height: 200.0, price: 913.0 },
      { width: 315.0, height: 200.0, price: 1336.0 },
      { width: 365.0, height: 200.0, price: 2207.0 },
      { width: 400.0, height: 200.0, price: 2418.0 },
    ],
    double: [
      { width: 335.0, height: 125.0, price: 1730.0 },
      { width: 415.0, height: 125.0, price: 1760.0 },
      { width: 455.0, height: 125.0, price: 1931.0 },
      { width: 555.0, height: 125.0, price: 2355.0 },
      { width: 615.0, height: 125.0, price: 3677.0 },
      { width: 335.0, height: 150.0, price: 1850.0 },
      { width: 415.0, height: 150.0, price: 1887.0 },
      { width: 455.0, height: 150.0, price: 2072.0 },
      { width: 555.0, height: 150.0, price: 2527.0 },
      { width: 615.0, height: 150.0, price: 3851.0 },
      { width: 335.0, height: 175.0, price: 1968.0 },
      { width: 415.0, height: 175.0, price: 2015.0 },
      { width: 455.0, height: 175.0, price: 2212.0 },
      { width: 555.0, height: 175.0, price: 2696.0 },
      { width: 615.0, height: 175.0, price: 4016.0 },
      { width: 335.0, height: 200.0, price: 2084.0 },
      { width: 415.0, height: 200.0, price: 2142.0 },
      { width: 455.0, height: 200.0, price: 2351.0 },
      { width: 555.0, height: 200.0, price: 2867.0 },
      { width: 615.0, height: 200.0, price: 4191.0 },
    ],
    sliding: [
      { width: 325.0, height: 125.0, price: 2170.0 },
      { width: 375.0, height: 125.0, price: 2256.0 },
      { width: 425.0, height: 125.0, price: 2337.0 },
      { width: 475.0, height: 125.0, price: 2420.0 },
      { width: 525.0, height: 125.0, price: 2527.0 },
      { width: 625.0, height: 125.0, price: 3601.0 },
      { width: 710.0, height: 125.0, price: 4090.0 },
      { width: 800.0, height: 125.0, price: 4608.0 },
      { width: 325.0, height: 150.0, price: 2265.0 },
      { width: 375.0, height: 150.0, price: 2365.0 },
      { width: 425.0, height: 150.0, price: 2492.0 },
      { width: 475.0, height: 150.0, price: 2564.0 },
      { width: 525.0, height: 150.0, price: 2659.0 },
      { width: 625.0, height: 150.0, price: 3770.0 },
      { width: 710.0, height: 150.0, price: 4280.0 },
      { width: 800.0, height: 150.0, price: 4821.0 },
      { width: 325.0, height: 175.0, price: 2337.0 },
      { width: 375.0, height: 175.0, price: 2446.0 },
      { width: 425.0, height: 175.0, price: 2624.0 },
      { width: 475.0, height: 175.0, price: 2686.0 },
      { width: 525.0, height: 175.0, price: 2770.0 },
      { width: 625.0, height: 175.0, price: 3912.0 },
      { width: 710.0, height: 175.0, price: 4442.0 },
      { width: 800.0, height: 175.0, price: 5005.0 },
      { width: 325.0, height: 200.0, price: 2408.0 },
      { width: 375.0, height: 200.0, price: 2531.0 },
      { width: 425.0, height: 200.0, price: 2754.0 },
      { width: 475.0, height: 200.0, price: 2805.0 },
      { width: 525.0, height: 200.0, price: 2883.0 },
      { width: 625.0, height: 200.0, price: 4057.0 },
      { width: 710.0, height: 200.0, price: 4609.0 },
      { width: 800.0, height: 200.0, price: 5194.0 },
    ],
  },
  'lunar': {
    pedestrian: [
      { width: 135.0, height: 124.0, price: 577.0 },
      { width: 215.0, height: 124.0, price: 750.0 },
      { width: 265.0, height: 124.0, price: 1149.0 },
      { width: 335.0, height: 124.0, price: 1320.0 },
      { width: 400.0, height: 124.0, price: 2346.0 },
      { width: 135.0, height: 148.0, price: 611.0 },
      { width: 215.0, height: 148.0, price: 783.0 },
      { width: 265.0, height: 148.0, price: 1241.0 },
      { width: 335.0, height: 148.0, price: 1413.0 },
      { width: 400.0, height: 148.0, price: 2439.0 },
      { width: 135.0, height: 172.0, price: 648.0 },
      { width: 215.0, height: 172.0, price: 818.0 },
      { width: 265.0, height: 172.0, price: 1331.0 },
      { width: 335.0, height: 172.0, price: 1501.0 },
      { width: 135.0, height: 196.0, price: 681.0 },
      { width: 215.0, height: 196.0, price: 855.0 },
      { width: 265.0, height: 196.0, price: 1424.0 },
      { width: 335.0, height: 196.0, price: 1596.0 },
    ],
    double: [
      { width: 335.0, height: 124.0, price: 1417.0 },
      { width: 415.0, height: 124.0, price: 1500.0 },
      { width: 455.0, height: 124.0, price: 1737.0 },
      { width: 515.0, height: 124.0, price: 1978.0 },
      { width: 600.0, height: 124.0, price: 2392.0 },
      { width: 335.0, height: 148.0, price: 1519.0 },
      { width: 415.0, height: 148.0, price: 1614.0 },
      { width: 455.0, height: 148.0, price: 1871.0 },
      { width: 515.0, height: 148.0, price: 2135.0 },
      { width: 600.0, height: 148.0, price: 2550.0 },
      { width: 335.0, height: 172.0, price: 1624.0 },
      { width: 415.0, height: 172.0, price: 1727.0 },
      { width: 455.0, height: 172.0, price: 2012.0 },
      { width: 515.0, height: 172.0, price: 2297.0 },
      { width: 600.0, height: 172.0, price: 2716.0 },
      { width: 335.0, height: 196.0, price: 1727.0 },
      { width: 415.0, height: 196.0, price: 1841.0 },
      { width: 455.0, height: 196.0, price: 2152.0 },
      { width: 515.0, height: 196.0, price: 2462.0 },
      { width: 600.0, height: 196.0, price: 2878.0 },
    ],
    sliding: [
      { width: 325.0, height: 124.0, price: 2276.0 },
      { width: 375.0, height: 124.0, price: 2394.0 },
      { width: 425.0, height: 124.0, price: 2517.0 },
      { width: 475.0, height: 124.0, price: 2635.0 },
      { width: 525.0, height: 124.0, price: 2985.0 },
      { width: 620.0, height: 124.0, price: 3251.0 },
      { width: 710.0, height: 124.0, price: 5261.0 },
      { width: 800.0, height: 124.0, price: 5269.0 },
      { width: 325.0, height: 148.0, price: 2346.0 },
      { width: 375.0, height: 148.0, price: 2480.0 },
      { width: 425.0, height: 148.0, price: 2612.0 },
      { width: 475.0, height: 148.0, price: 2742.0 },
      { width: 525.0, height: 148.0, price: 3105.0 },
      { width: 620.0, height: 148.0, price: 3372.0 },
      { width: 710.0, height: 148.0, price: 5384.0 },
      { width: 800.0, height: 148.0, price: 5373.0 },
      { width: 325.0, height: 172.0, price: 2420.0 },
      { width: 375.0, height: 172.0, price: 2564.0 },
      { width: 425.0, height: 172.0, price: 2705.0 },
      { width: 475.0, height: 172.0, price: 2849.0 },
      { width: 525.0, height: 172.0, price: 3224.0 },
      { width: 620.0, height: 172.0, price: 3490.0 },
      { width: 710.0, height: 172.0, price: 5504.0 },
      { width: 325.0, height: 196.0, price: 2492.0 },
      { width: 375.0, height: 196.0, price: 2651.0 },
      { width: 425.0, height: 196.0, price: 2802.0 },
      { width: 475.0, height: 196.0, price: 2957.0 },
      { width: 525.0, height: 196.0, price: 3348.0 },
      { width: 620.0, height: 196.0, price: 3610.0 },
      { width: 710.0, height: 196.0, price: 5650.0 },
    ],
  },
  'solaris': {
    pedestrian: [
      { width: 135.0, height: 125.0, price: 565.0 },
      { width: 215.0, height: 125.0, price: 739.0 },
      { width: 315.0, height: 125.0, price: 1271.0 },
      { width: 365.0, height: 125.0, price: 1339.0 },
      { width: 400.0, height: 125.0, price: 1991.0 },
      { width: 135.0, height: 150.0, price: 612.0 },
      { width: 215.0, height: 150.0, price: 787.0 },
      { width: 315.0, height: 150.0, price: 1364.0 },
      { width: 365.0, height: 150.0, price: 1431.0 },
      { width: 400.0, height: 150.0, price: 2054.0 },
      { width: 135.0, height: 175.0, price: 658.0 },
      { width: 215.0, height: 175.0, price: 832.0 },
      { width: 315.0, height: 175.0, price: 1456.0 },
      { width: 365.0, height: 175.0, price: 1524.0 },
      { width: 400.0, height: 175.0, price: 2117.0 },
      { width: 135.0, height: 200.0, price: 704.0 },
      { width: 215.0, height: 200.0, price: 880.0 },
      { width: 315.0, height: 200.0, price: 1545.0 },
      { width: 365.0, height: 200.0, price: 1614.0 },
      { width: 400.0, height: 200.0, price: 2191.0 },
    ],
    double: [
      { width: 335.0, height: 125.0, price: 1503.0 },
      { width: 415.0, height: 125.0, price: 1558.0 },
      { width: 455.0, height: 125.0, price: 1617.0 },
      { width: 555.0, height: 125.0, price: 2142.0 },
      { width: 655.0, height: 125.0, price: 3729.0 },
      { width: 335.0, height: 150.0, price: 1605.0 },
      { width: 415.0, height: 150.0, price: 1676.0 },
      { width: 455.0, height: 150.0, price: 1742.0 },
      { width: 555.0, height: 150.0, price: 2272.0 },
      { width: 655.0, height: 150.0, price: 3868.0 },
      { width: 335.0, height: 175.0, price: 1712.0 },
      { width: 415.0, height: 175.0, price: 1788.0 },
      { width: 455.0, height: 175.0, price: 1878.0 },
      { width: 555.0, height: 175.0, price: 2420.0 },
      { width: 655.0, height: 175.0, price: 4006.0 },
      { width: 335.0, height: 200.0, price: 1813.0 },
      { width: 415.0, height: 200.0, price: 1904.0 },
      { width: 455.0, height: 200.0, price: 1996.0 },
      { width: 555.0, height: 200.0, price: 2568.0 },
      { width: 655.0, height: 200.0, price: 4145.0 },
    ],
    sliding: [
      { width: 325.0, height: 125.0, price: 2087.0 },
      { width: 375.0, height: 125.0, price: 2204.0 },
      { width: 425.0, height: 125.0, price: 2321.0 },
      { width: 475.0, height: 125.0, price: 2436.0 },
      { width: 525.0, height: 125.0, price: 2816.0 },
      { width: 625.0, height: 125.0, price: 3751.0 },
      { width: 710.0, height: 125.0, price: 4201.0 },
      { width: 800.0, height: 125.0, price: 5650.0 },
      { width: 325.0, height: 150.0, price: 2170.0 },
      { width: 375.0, height: 150.0, price: 2297.0 },
      { width: 425.0, height: 150.0, price: 2424.0 },
      { width: 475.0, height: 150.0, price: 2550.0 },
      { width: 525.0, height: 150.0, price: 2943.0 },
      { width: 625.0, height: 150.0, price: 3890.0 },
      { width: 710.0, height: 150.0, price: 4268.0 },
      { width: 800.0, height: 150.0, price: 5720.0 },
      { width: 325.0, height: 175.0, price: 2228.0 },
      { width: 375.0, height: 175.0, price: 2367.0 },
      { width: 425.0, height: 175.0, price: 2503.0 },
      { width: 475.0, height: 175.0, price: 2644.0 },
      { width: 525.0, height: 175.0, price: 3048.0 },
      { width: 625.0, height: 175.0, price: 4004.0 },
      { width: 710.0, height: 175.0, price: 4337.0 },
      { width: 800.0, height: 175.0, price: 5789.0 },
      { width: 325.0, height: 200.0, price: 2284.0 },
      { width: 375.0, height: 200.0, price: 2436.0 },
      { width: 425.0, height: 200.0, price: 2584.0 },
      { width: 475.0, height: 200.0, price: 2735.0 },
      { width: 525.0, height: 200.0, price: 3150.0 },
      { width: 625.0, height: 200.0, price: 4120.0 },
      { width: 710.0, height: 200.0, price: 4405.0 },
      { width: 800.0, height: 200.0, price: 5854.0 },
    ],
  },
}

// Find nearest price using ceiling approach
const findNearestPrice = (prices, targetWidth, targetHeight) => {
  // Filter by exact width or next larger width
  const widths = [...new Set(prices.map(p => p.width))].sort((a, b) => a - b);
  let selectedWidth = widths.find(w => w >= targetWidth) || widths[widths.length - 1];
  
  // Get prices for selected width
  const widthPrices = prices.filter(p => p.width === selectedWidth);
  
  // Find exact height or next larger height
  const heights = widthPrices.map(p => p.height).sort((a, b) => a - b);
  let selectedHeight = heights.find(h => h >= targetHeight) || heights[heights.length - 1];
  
  const match = widthPrices.find(p => p.height === selectedHeight);
  return match ? match.price : 0;
};

export const getGatePrice = (modelId, gateType, width, height) => {
  const modelPricing = gatePricing[modelId.toLowerCase()];
  if (!modelPricing) return 0;
  
  const typePricing = modelPricing[gateType];
  if (!typePricing || typePricing.length === 0) return 0;
  
  return findNearestPrice(typePricing, width, height);
};

// Get available widths for a gate type and model
export const getAvailableWidths = (modelId, gateType) => {
  const modelPricing = gatePricing[modelId.toLowerCase()];
  if (!modelPricing) return [];
  
  const typePricing = modelPricing[gateType];
  if (!typePricing) return [];
  
  return [...new Set(typePricing.map(p => p.width))].sort((a, b) => a - b);
};

// Get available heights for a gate type and model
export const getAvailableHeights = (modelId, gateType) => {
  const modelPricing = gatePricing[modelId.toLowerCase()];
  if (!modelPricing) return [];
  
  const typePricing = modelPricing[gateType];
  if (!typePricing) return [];
  
  return [...new Set(typePricing.map(p => p.height))].sort((a, b) => a - b);
};
